'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('TechElementDetailsCtrl', TechElementDetailsCtrl);

  TechElementDetailsCtrl.$inject = ['TechnicalElementsAPI', 'Constants', 'technicalElements',
    'errorMessageService', 'Labels', '$mdDialog', '$timeout', 'TechElementModuleService', 'TechElementSubmoduleService'];

  function TechElementDetailsCtrl (TechnicalElementsAPI, Constants, technicalElements,
    errorMessageService, Labels, $mdDialog, $timeout, TechElementModuleService, TechElementSubmoduleService) {

    const vm = this;
    vm.technicalElements = technicalElements;

    vm.modules = vm.technicalElements;
    vm.units = Constants.getList('UNIT_TYPES');
    vm.elementTypes = Constants.getList('ELEMENT_TYPES');
    vm.LABELS = Labels;

    vm.$onInit = function () {
      vm.model = Object.assign({}, vm.model);

      if (!vm.model.module && !vm.model.submodule) {
        vm.model.module = {};
        vm.model.submodule = {};
        vm.model.module._id = vm.modules[0]._id;
        vm.model.module.submodules = vm.modules[0].submodules;
        vm.model.submodule._id = vm.model.module.submodules[0]._id;  
      } else {
        const module = vm.modules.find((module) => module._id === vm.model.module._id)
        vm.model.module.submodules = module.submodules;
      }
    };

    vm.submitTechElement = function (addanother = false) {
      if (vm.form.$valid &&
        angular.isDefined(vm.model.module) &&
        angular.isDefined(vm.model.submodule)) {

        // create an object only containing needed information
        const element = {
          name: vm.model.name,
          _id: vm.model._id,
          unit: vm.model.unit,
          type: vm.model.type,
          info: vm.model.info,
          module: {_id: vm.model.module._id},
          submodule: {_id: vm.model.submodule._id},
          selectOptions: vm.model.selectOptions,
          active: true
        };

        if (vm.model._id) {
          TechnicalElementsAPI.updateElement({
            element: element,
            id: vm.model._id
          }).$promise.then(function (updatedElements) {
            errorMessageService.showSuccess(Labels.getLabel('saved'));
            $mdDialog.hide(updatedElements);
          });
        } else {
          TechnicalElementsAPI.createElement({element: element}).$promise.then(function (updatedElements) {
            errorMessageService.showSuccess(Labels.getLabel('specificationadded'));

            if (!addanother) {
              $mdDialog.hide(updatedElements);
            } else {
              resetForm();
            }

          });
        }

      } else {
        errorMessageService.showWarning(Labels.getLabel('saveerror'));
      }
    };

    // Cancel dialog
    vm.cancel = (updatedProject, redirectUrl) => {
      $mdDialog.cancel();
    };

    vm.openAddModuleDialog = function (ev) {
      TechElementModuleService.open(ev, vm.model).then(updateAndSelectModules);
    };

    function updateAndSelectModules (updatedModules) {
      vm.modules = updatedModules;
      
      $timeout(() => {
        vm.model.module = {_id: updatedModules[updatedModules.length - 1]._id};
        const module = vm.modules.find((module) => {
          return module._id === vm.model.module._id
        });
        vm.model.module.submodules = module ? module.submodules : [];
  
        vm.model.submodule = {_id: vm.model.module.submodules[vm.model.module.submodules.length - 1]._id};
      });
    }

    vm.openAddSubmoduleDialog = function (ev) {
      TechElementSubmoduleService.open(ev, vm.model).then(updateAndSelectSubmodules);
    };

    function updateAndSelectSubmodules (updatedModules) {
      vm.modules = updatedModules;
      const module = vm.modules.find((module) => module._id === vm.model.module._id)
      vm.model.module.submodules = module.submodules;

      // Wait for UI to update, then we can get the submodules from the current module selection
      $timeout(() => {
        vm.model.submodule = {_id: vm.model.module.submodules[vm.model.module.submodules.length - 1]._id};
      });
    }

    function resetForm () {
      vm.model.name = '';
      vm.model.info = '';
      vm.form.$setPristine(true);
      vm.form.$setUntouched(true);
    }
  }

})();
